import { forwardRef } from "react";
import { StyledSidebarSection } from "./SidebarSection.style.js";
import type { SidebarSectionProps } from "./SidebarSection.types.js";

export const SidebarSection = forwardRef<HTMLDivElement, SidebarSectionProps>(({ children }, ref): JSX.Element => {
    return <StyledSidebarSection ref={ref}>{children}</StyledSidebarSection>;
});
